export const SET_CURRENT_EVENT = 'SET_CURRENT_EVENT'
export const LOAD_EVENT_STATUS_ENUM = 'LOAD_EVENT_STATUS_ENUM'
export const LOAD_EVENT_STATUS = 'LOAD_EVENT_STATUS'
export const LOAD_EVENT_PARTICIPATOR_TYPE = 'LOAD_EVENT_PARTICIPATOR_TYPE'
export const LOAD_EVENT_PERMISSIONS = 'LOAD_EVENT_PERMISSIONS'
export const LOAD_EVENT_INSCRIPTION_STATUS = 'LOAD_EVENT_INSCRIPTION_STATUS'
export const LOAD_EVENT_PARTICIPATORS = 'LOAD_EVENT_PARTICIPATORS'
export const LOAD_VARIABLES = 'LOAD_VARIABLES'
export const LOAD_EVENT_INVITATION_STATUS = 'LOAD_EVENT_INVITATION_STATUS'
export const LOAD_TEMPLATE_KEY = 'LOAD_TEMPLATE_KEY'
export const SET_CURRENT_INVITATION = 'SET_CURRENT_INVITATION'
export const LOAD_EVENT_VALIDATED_PARTICIPATORS = 'LOAD_EVENT_VALIDATED_PARTICIPATORS'

